import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from '../constants/dictionary.constant';

export const tabOptions = (data, currentStatus) => {
	return [
		{
			key: 'pending',
			tab: Dictionary[Enviroment.LANGUAGE].pending,
			data: currentStatus === 'PAYMENT_PENDING' ? data : [],
			status: 'PAYMENT_PENDING',
		},
		{
			key: 'paid',
			tab: Dictionary[Enviroment.LANGUAGE].paid,
			data: currentStatus === 'PAYMENT_APPROVED' ? data : [],
			status: 'PAYMENT_APPROVED',
		}
		
	];
};
